import type { SyntheticEvent } from "react";

import classNames from "classnames";

import { ImageBehaviour } from "@jti/core-components/components/ImageBehaviour";
import { LinkBehaviour } from "@jti/core-components/components/LinkBehaviour";
import { useMessageBus } from "@jti/fe-message-bus";

import type { SocialMediaLink } from "./types";

import styles from "./SocialLinks.module.scss";

export type SocialLinksProps = {
  links: SocialMediaLink[];
  className?: string;
  dataTestId?: string;
};

export const SocialLinks = ({ links, className = "", dataTestId = "socials" }: SocialLinksProps) => {
  const messageBus = useMessageBus();
  const handleSocialClick = (event: SyntheticEvent<HTMLAnchorElement, Event>, socialNetwork: string) => {
    event.preventDefault();

    messageBus.publish("tracking.event", {
      payload: {
        event_name: "follow",
        additionalData: {
          social_network: socialNetwork,
        },
      },
    });

    window.open(event.currentTarget.href, event.currentTarget.target);
  };

  return (
    <div className={classNames(styles.socialsWrapper, className)} data-testid={dataTestId}>
      {links.map(({ trackingName, link, image }) => (
        <LinkBehaviour
          key={trackingName}
          className={styles.socialLink}
          href={link}
          target="_blank"
          rel="noreferrer"
          data-testid={trackingName}
          onClick={(event) => handleSocialClick(event, trackingName)}
        >
          <ImageBehaviour className={styles.socialImg} src={image.src} alt={image.alt} />
        </LinkBehaviour>
      ))}
    </div>
  );
};
